import styled from 'styled-components';
import { Button } from '@m/alchemy-ui/Button';
import { color, units } from '@m/alchemy-ui/theme';

export const FormContainer = styled.div``;

export const FormHeading = styled.p`
  margin-bottom: ${units(2)};
`;

export const ErrorAlert = styled.div.attrs({ className: 'mdl-alert -error' })``;

export const FieldsList = styled.ul`
  list-style: none;
  margin: 0;

  @media (min-width: 800px) {
    display: flex;
    gap: ${units(2)};
  }
`;

export const FieldItem = styled.li`
  margin-bottom: ${units(2)};

  @media (min-width: 800px) {
    flex: 1;
    margin-bottom: 0;
  }
`;

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: ${units(0.5)};
`;

export const FieldInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid ${color('inputBorder')};
  border-radius: 16px;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: ${color('base', { palette: 'interactiveConstructive' })};
    box-shadow: 0 0 0 1px ${color('base', { palette: 'interactiveConstructive' })};
  }

  &::placeholder {
    color: ${color('hint')};
  }
`;

export const RememberMeList = styled.ul`
  margin: ${units(2)} 0 0;
  text-align: right;
`;

export const RememberMeLabel = styled.label`
  display: inline-flex;
  gap: ${units(1)};
  cursor: pointer;
`;

export const RememberMeCheckbox = styled.input``;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${units(2.5)};
  padding: ${units(2)} 0;
  border-top: 1px solid ${color('line')};

  @media (max-width: 400px) {
    flex-direction: column;
    padding: 0;

    & > * {
      margin: 0;
      width: 100%;
      padding: ${units(1.25)} 0;
    }
  }
`;

export const ForgotPasswordLink = styled.a`
  margin-right: auto;

  &:hover {
    text-decoration: underline;
  }
`;

export const SubmitButton = styled(Button)``;
